import React, { useState, useEffect } from "react";
import { Modal, Select, BlockStack, Text, Banner } from "@shopify/polaris";
import supabase from "../../supabase-client";

// Reassigns reservations.created_by (the reservation's responsable, which drives
// commissions). The trg_reservations_owner_change trigger is authoritative: only
// the current owner or a superadmin may change it, and only to a user with a
// name and email. Every change is logged to reservation_owner_changes.
function ChangeOwnerModal({ open, onClose, reservationId, currentOwnerId, onSaved }) {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setSelected(currentOwnerId || "");
    setError("");
    supabase
      .from("users")
      .select("id, name, email")
      .neq("name", "")
      .neq("email", "")
      .not("name", "is", null)
      .not("email", "is", null)
      .is("deleted_at", null)
      .order("name")
      .then(({ data, error }) => {
        if (error) setError(error.message);
        else setUsers(data || []);
      });
  }, [open, currentOwnerId]);

  const save = async () => {
    setSaving(true);
    setError("");
    const { error } = await supabase
      .from("reservations")
      .update({ created_by: selected })
      .eq("id", reservationId);
    setSaving(false);
    if (error) {
      setError(error.message);
      return;
    }
    onSaved?.();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Cambiar responsable"
      primaryAction={{
        content: "Guardar",
        onAction: save,
        loading: saving,
        disabled: !selected || selected === currentOwnerId,
      }}
      secondaryActions={[{ content: "Cancelar", onAction: onClose }]}
    >
      <Modal.Section>
        <BlockStack gap="300">
          {error && <Banner tone="critical">{error}</Banner>}
          <Select
            label="Responsable"
            options={[
              ...(currentOwnerId ? [] : [{ label: "Sin asignar", value: "" }]),
              ...users.map((u) => ({ label: u.name, value: u.id })),
            ]}
            value={selected}
            onChange={setSelected}
          />
          <Text as="p" tone="subdued">
            Una vez reasignada, solo el nuevo responsable (o un superadmin) podrá
            volver a cambiarla.
          </Text>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}

export default ChangeOwnerModal;
